<section id="content1" class="fbo-tab-content paddingtop-0 left-padding-10">
    <div *ngIf="!isautoShipDetail">
        <div>
            <h5>{{'customer-service.Autoship Summary' |translate}}</h5>
        </div>
        <div class="row table-section">
            <div class="col-xs-12">
                <div class="form-group col-xs-12 col-sm-6 col-md-3 no-padding">
                    <label for="Status">
                        {{'customer-service.Status' |translate}}
                        <span title=" {{'catalog.Status' |translate}}" class="ico-help fa fa-question-circle"></span>
                    </label>
                    <select class="form-control" tabindex="0" [(ngModel)]="autoshipStatus">
                        <option [value]="0">--Select--</option>
                        <option *ngFor="let status of STATUS" [value]="status.id">{{status.name}}</option>
                    </select>
                </div>
                <div class="form-group col-xs-12 col-md-1 margintop-32">
                    <button class="btn search-button" tabindex="0" type="button" (click)="onFilterStatus()">
                        <i class="fa fa-search pad-r-8"></i> {{' department-system.Search' |translate}}
                    </button>
                </div>
            </div>

            <div class="col-sm-9">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="headerWhite" tabindex="0">
                                <strong>{{'customer-service.Scheduled Run Day' |translate}}
                                </strong>
                            </th>
                            <th class="headerWhite" tabindex="0">
                                <strong>{{'customer-service.Autoship Name' |translate}}
                                </strong>
                            </th>
                            <th class="headerWhite" tabindex="0">
                                <strong>{{'customer-service.Next Autoship Run Date' |translate}}
                                </strong>
                            </th>
                            <th class="headerWhite">
                                <strong>{{'customer-service.Status' |translate}}
                                </strong>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="autoShipInfo">
                        <tr *ngFor="let autoship of autoShipInfo">
                            <td>
                                {{autoship.startDate | date: 'dd'}}
                            </td>
                            <td>
                                <a class="pointerstyle" (click)="getAutoshipInfo(autoship)">{{autoship.name}}</a>
                            </td>
                            <td *ngIf="autoship.nextAutoshipRunDate">{{autoship.nextAutoshipRunDate | date: 'dd-MMM-yyyy'}}</td>
                            <td *ngIf="!autoship.nextAutoshipRunDate">NA</td>                            
                            <td *ngIf="autoship.autoshipStatusId === 1">Active</td>
                            <td *ngIf="!(autoship.autoshipStatusId === 1)">Inactive</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!autoShipInfo || autoShipInfo?.length==0">
                        <tr>
                            <td colspan="4">No Record(s) found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- <div *ngIf="isautoShipDetail">
        <i _ngcontent-c9="" class="fa fa-arrow-circle-left pad-r-8"></i>
        <a class="backlink pointerstyle" tabindex="0" (keyup.enter)="backtoAutoShipHistory()" (click)="backtoAutoShipHistory()">{{'customer-service.Back to Autoship Summary' |translate}} </a>
        <ul class="col-sm-12 list-style-none list-group orderdet-column clearfix" style="padding-right:0;">
            <li class="col-xs-4">
                <div class="list-group-item">
                    <div class="heading-block">{{'customer-service.Autoship Details' |translate}}</div>
                    <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-6">
                            <label>{{'customer-service.Name' |translate}}</label>
                        </div>
                        <div class="col-xs-6 col-sm-6">
                            : &nbsp;{{orderInformation.userName}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-6">
                            <label>{{'customer-service.Template ID' |translate}}</label>
                        </div>
                        <div class="col-xs-6 col-sm-6">
                            : &nbsp;{{orderInformation.orderNumber}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-6">
                            <label>{{'customer-service.Scheduled Date' |translate}}</label>
                        </div>
                        <div class="col-xs-6 col-sm-6">
                            : &nbsp;{{orderInformation.orderDate|date:'dd-MMM-yyyy'}}
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-xs-4">
                <div class="list-group-item">
                    <div class="heading-block">{{'customer-service.Billing Information' |translate}}</div>
                    <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-6">
                            <label class="">{{'customer-service.Address' |translate}}</label>
                        </div>
                        <div class="col-xs-6 col-sm-6">
                            : &nbsp;{{orderInformation.billingInfo.address.addressFirstLine}} {{orderInformation.billingInfo.address.addressSecondLine?
                            ', orderInformation.billingInfo.address.addressSecondLine' : ''}} {{orderInformation.billingInfo.address.state?
                            (', '+orderInformation.billingInfo.address.state) : ''}} {{orderInformation.billingInfo.address.country?(',
                            '+orderInformation.billingInfo.address.country):''}}
                            <i class="glyphicon glyphicon-map-marker"></i>
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-xs-4">
                <div class="list-group-item">
                    <div class="heading-block">{{'customer-service.Shipping Information' |translate}}</div>
                    
                    <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-6">
                            <label class="">{{'customer-service.Shipping Address' |translate}}</label>
                        </div>
                        <div class="col-xs-6 col-sm-6">
                            : &nbsp;{{orderInformation.shippingInfo.address.addressFirstLine}} {{orderInformation.shippingInfo.address.addressSecondLine?(',
                            '+orderInformation.shippingInfo.address.addressSecondLine) : ''}} {{orderInformation.shippingInfo.address.state?
                            (', '+orderInformation.shippingInfo.address.state) : ''}} {{orderInformation.shippingInfo.address.country}}
                            <i class="glyphicon glyphicon-map-marker"></i>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div> -->
    <div class="row" *ngIf="isautoShipDetail">
        <div class="col-xs-12 col-md-9">
            <i _ngcontent-c9="" class="fa fa-arrow-circle-left pad-r-8"></i>
            <a class="backlink pointerstyle" tabindex="0" (keyup.enter)="backtoAutoShipHistory()" (click)="backtoAutoShipHistory()">{{'customer-service.Back to Autoship Summary' |translate}} </a>
            <div class="row">
                <div class="col-xs-12 paddingtop-10">
                    <div class="panel panel-default autoship">
                        <div class="panel-body no-padding">
                            <div class="table-responsive">
                                <table class="table table-condensed">
                                    <tr>
                                        <td class="autoship-table heading" colspan="2">
                                            <strong>Autoship Name: </strong>
                                            <strong>{{selecteAutoShip.name}}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="autoship-table" colspan="2">
                                            <table class="table table-condensed">
                                                <thead>
                                                    <tr>
                                                        <th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.SKU' |translate}}
                                                            </strong>
                                                        </th>
                                                        <th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.Product Description' |translate}}
                                                            </strong>
                                                        </th>
                                                        <th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.Unit Price' |translate}}
                                                            </strong>
                                                        </th>
                                                        <th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.Quantity' |translate}}
                                                            </strong>
                                                        </th>
                                                        <th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.Price' |translate}}
                                                            </strong>
                                                        </th>
                                                        <!--<th class="headerWhite" tabindex="0">
                                                            <strong>{{'customer-service.CC' |translate}}
                                                            </strong>
                                                        </th>-->
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="productsInfo && productsInfo.length > 0">
                                                    <tr *ngFor="let productInfo of productsInfo">
                                                        <td>{{productInfo.itemNumber}}</td>
                                                        <td class="">{{productInfo.name}} </td>
                                                        <td class="">{{autoshipTabInfo.currencySymbol?autoshipTabInfo.currencySymbol:''}}{{productInfo.applicablePrice.toFixed(2)}}</td>
                                                        <td class="">{{productInfo.quantity}}</td>
                                                        <td class="">{{autoshipTabInfo.currencySymbol?autoshipTabInfo.currencySymbol:''}}{{(productInfo.quantity*productInfo.applicablePrice).toFixed(2)}}</td>
                                                        <!--<td>{{productInfo.cc}}</td>-->
                                                    </tr>
                                                </tbody>
                                                <tbody *ngIf="productInfo?.length == 0">
                                                    <tr>
                                                        <td colspan="8 " class="text-center ">{{'customer-service.No records found' |translate}}.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="autoship-table">
                                            <table class="table table-condensed">
                                                <thead>
                                                    <tr>
                                                        <th>{{'customer-service.Shipping Address' |translate}}</th>
                                                        <th>{{'customer-service.Billing Address' |translate}}</th>
                                                        <th>{{'customer-service.Delivery Date' |translate}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td *ngIf="shippingAddress">
                                                            <!--<div class="row" *ngIf="shippingAddress.shipToName">{{shippingAddress.shipToName}}</div>-->
                                                            <div>{{shippingAddress.addressLine1}} {{shippingAddress.addressLine2?shippingAddress.addressLine2:''}}</div>
                                                            <div>{{shippingAddress.addressLine3?shippingAddress.addressLine3:''}}
                                                                {{shippingAddress.addressLine4?shippingAddress.addressLine4:''}}
                                                            </div>
                                                            <div>{{shippingAddress.city?shippingAddress.city:''}} {{shippingAddress.state?shippingAddress.state:''}}</div>
                                                            <div>{{shippingAddress.postalCode?shippingAddress.postalCode:''}}</div>
                                                            <div>{{shippingAddress.country?shippingAddress.country:''}}</div>
                                                        </td>
                                                        <td *ngIf="!shippingAddress">NA</td>
                                                        <td *ngIf="billingAddress">
                                                            <!--<div class="row">{{billingAddress.shipToName}}</div>-->
                                                            <div>{{billingAddress.addressLine1}} {{billingAddress.addressLine2?billingAddress.addressLine2:''}}</div>
                                                            <div>{{billingAddress.addressLine3?billingAddress.addressLine3:''}}
                                                                {{billingAddress.addressLine4?billingAddress.addressLine4:''}}
                                                            </div>
                                                            <div>{{billingAddress.city?billingAddress.city:''}} {{billingAddress.state?billingAddress.state:''}}</div>
                                                            <div>{{billingAddress.postalCode?billingAddress.postalCode:''}}</div>
                                                            <div>{{billingAddress.country?billingAddress.country:''}}</div>
                                                        </td>
                                                        <td *ngIf="!billingAddress">NA</td>
                                                        <td *ngIf="selecteAutoShip.nextAutoshipRunDate">{{selecteAutoShip.nextAutoshipRunDate |date:'dd-MMM-yyyy'}}</td>
                                                        <td *ngIf="!selecteAutoShip.nextAutoshipRunDate">NA</td>
                                                        
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td colspan="2" class="autoship-table">
                                            <table class="table table-condensed">
                                                <thead>
                                                    <tr>
                                                        <th>{{'customer-service.Payment Information' |translate}}</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div *ngIf="paymentDetails">
                                                                <div class="row">
                                                                    <div class="col-xs-6 col-sm-4 col-md-6">
                                                                        {{'customer-service.Credit Card Type' |translate}}
                                                                    </div>
                                                                    <div class="col-xs-6 col-sm-6">
                                                                        : &nbsp;{{paymentDetails.cardType}}
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-xs-6 col-sm-4 col-md-6">
                                                                        {{'customer-service.Card Number' |translate}}
                                                                    </div>
                                                                    <div class="col-xs-6 col-sm-6">
                                                                        : &nbsp;Ending in {{paymentDetails.maskedCard}}
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-xs-6 col-sm-4 col-md-6">
                                                                        {{'customer-service.Expiry Date' |translate}} 
                                                                    </div>
                                                                    <div class="col-xs-6 col-sm-6">
                                                                        : &nbsp;  {{"01/"+paymentDetails.expiryMonth+"/"+paymentDetails.expiryYear.substring(2,4) | date: 'MMM/yyyy'}} 
                                                                        <!-- .substring(2,4) -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="autoship-table heading">
                                            <strong>
                                                    {{'customer-service.TAXES' |translate}}
                                            </strong>
                                        </td>
                                        <td class="autoship-table heading">
                                            <strong>{{autoshipTabInfo.currencySymbol}} {{shippingCharge.toFixed(2)}}</strong>
                                        </td>
                                    </tr>
                                     <tr>
                                        <td class="autoship-table heading">
                                            <strong>{{'customer-service.TOTAL CC' |translate}}</strong>
                                        </td>
                                        <td class="autoship-table heading">
                                            <strong>{{totalCommissionableVolume.toFixed(3)}} CC</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="autoship-table heading">
                                            <strong>{{'customer-service.TOTAL' |translate}}</strong>
                                        </td>
                                        <td class="autoship-table heading">
                                            <strong>{{autoshipTabInfo.currencySymbol}} {{subTotal.toFixed(2)}}</strong>
                                        </td>
                                    </tr>
                                   
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row" *ngIf="isautoShipDetail">
        <div>
            <div class="col-md-9 col-sm-12">
                <div class="panel panel-default">
                    <div class="panel-body no-padding">
                        <div class="table-responsive">
                            <table class="table table-condensed">
                                <thead>
                                    <tr>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('sku')" (click)="sortProductInformationByColumn('sku')">
                                            <strong>{{'customer-service.SKU' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'sku', 'fa-sort-asc': (sortColumn  == 'sku' && !isDesc), 'fa-sort-desc': (sortColumn  == 'sku' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('productDescription')" (click)="sortProductInformationByColumn('productDescription')">
                                            <strong>{{'customer-service.Product Description' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'productDescription', 'fa-sort-asc': (sortColumn  == 'productDescription' && !isDesc), 'fa-sort-desc': (sortColumn  == 'productDescription' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('unitPrice')" (click)="sortProductInformationByColumn('unitPrice')">
                                            <strong>{{'customer-service.Unit Price' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'unitPrice', 'fa-sort-asc': (sortColumn  == 'unitPrice' && !isDesc), 'fa-sort-desc': (sortColumn  == 'unitPrice' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('quantity')" (click)="sortProductInformationByColumn('quantity')">
                                            <strong>{{'customer-service.Quantity' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'quantity', 'fa-sort-asc': (sortColumn  == 'quantity' && !isDesc), 'fa-sort-desc': (sortColumn  == 'quantity' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('price')" (click)="sortProductInformationByColumn('price')">
                                            <strong>{{'customer-service.Price' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'price', 'fa-sort-asc': (sortColumn  == 'price' && !isDesc), 'fa-sort-desc': (sortColumn  == 'price' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortProductInformationByColumn('cc')" (click)="sortProductInformationByColumn('cc')">
                                            <strong>{{'customer-service.CC' |translate}}&nbsp;
                                                <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cc', 'fa-sort-asc': (sortColumn  == 'cc' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cc' && isDesc) }">
                                                </i>
                                            </strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="orderInformation.productInfo && orderInformation.productInfo.length > 0">
                                    <tr *ngFor="let productInfo of orderInformation.productInfo">
                                        <td>{{productInfo.sku}}</td>
                                        <td class="">{{productInfo.productDescription}} </td>
                                        <td class="">${{productInfo.unitPrice}}</td>
                                        <td class="">{{productInfo.quantity}}</td>
                                        <td class="">${{productInfo.price}}</td>
                                        <td>{{productInfo.cc}}</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="orderInformation.productInfo == 0">
                                    <tr>
                                        <td colspan="8 " class="text-center ">{{'customer-service.No records found' |translate}}.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <ul class="col-sm-12 list-group orderdet-column clearfix" style="padding-right:0;">
                    <li class="list-group-item">
                        <div class="heading-block">{{'customer-service.Order Summary' |translate}}</div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Subtotal' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>{{orderInformation.subTotal?(orderInformation.subTotal):'-'}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Shipping' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>{{orderInformation.shipping?(orderInformation.shipping):'-'}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Taxes' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>{{orderInformation.tax?(orderInformation.tax):'-'}}</label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Fees' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>- </label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Balance Applied' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>-</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Discount' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>-</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Total' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>{{orderInformation.total}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label class="">{{'customer-service.Total CC' |translate}} </label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;<label>{{orderInformation.totalCC}}</label>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-md-9">
            <div class="heading-block">
                {{'customer-service.Autoship History' |translate}}
            </div>
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortAutoshipHistoryByColumn('date')" (click)="sortAutoshipHistoryByColumn('date')"><strong>{{'customer-service.Date' |translate}}&nbsp;
                            <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': autoshipSortColumn != 'date', 'fa-sort-asc': (autoshipSortColumn  == 'date' && !autoshipIsDesc), 'fa-sort-desc': (autoshipSortColumn  == 'date' && autoshipIsDesc) }">
                         </i></strong></th>
                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortAutoshipHistoryByColumn('status')" (click)="sortAutoshipHistoryByColumn('status')"><strong>{{'customer-service.Status' |translate}}&nbsp;
                            <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': autoshipSortColumn != 'status', 'fa-sort-asc': (autoshipSortColumn  == 'status' && !autoshipIsDesc), 'fa-sort-desc': (autoshipSortColumn  == 'status' && autoshipIsDesc) }">
                         </i></strong></th>
                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortAutoshipHistoryByColumn('details')" (click)="sortAutoshipHistoryByColumn('details')"><strong>{{'customer-service.Details' |translate}}&nbsp;
                            <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': autoshipSortColumn != 'details', 'fa-sort-asc': (autoshipSortColumn  == 'details' && !autoshipIsDesc), 'fa-sort-desc': (autoshipSortColumn  == 'details' && autoshipIsDesc) }">
                         </i></strong></th>
                        <th class="headerWhite" tabindex="0" (keyup.enter)="sortAutoshipHistoryByColumn('code')" (click)="sortAutoshipHistoryByColumn('code')"><strong>{{'customer-service.Code' |translate}}&nbsp;
                            <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': autoshipSortColumn != 'code', 'fa-sort-asc': (autoshipSortColumn  == 'code' && !autoshipIsDesc), 'fa-sort-desc': (autoshipSortColumn  == 'code' && autoshipIsDesc) }">
                         </i></strong></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let autoship of autoShipHistory">
                        <td>
                            {{autoship.date}}
                        </td>
                        <td>
                            {{autoship.status}}
                        </td>
                        <td>
                            {{autoship.details}}
                        </td>
                        <td>
                            {{autoship.code}}
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div> -->

</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/autoship.component.html